export const ceclocation = location.origin
export const cecPaths = {
  index: ceclocation + '/', // ホーム
  item: {
    search: ceclocation + '/item/serch.html', // 商品検索
    list: ceclocation + '/item/list.html', // 一覧ページ
    ditail: ceclocation + '/item/detail.html', // 商品詳細
  },
  cart: {
    index: ceclocation + '/cart/', // カート
    destination: ceclocation + '/cart/destination', // 送付先入力
    payment: ceclocation + '/cart/paymentmethod',
    delivery: ceclocation + '/cart/delivery', // 決済・配送選択
    confirm: ceclocation + '/cart/confirm', // 注文内容確認
    complete: ceclocation + '/cart/complete', // 注文完了
  },
  onecart: ceclocation + '/onecart', // トライアルカート
  accounts: {
    login: ceclocation + '/login/', // ログイン
    registration: ceclocation + '/accounts/registration.html', // 会員登録
    complete: ceclocation + '/accounts/complete.html', // 会員登録完了
    passwordAsk: ceclocation + '/accounts/password_ask.html', // パスワード再設定メール送信
    passwordAskComplete: ceclocation + '/accounts/password_ask_complete.html', // パスワード再設定メール送信完了
    passwordReset: ceclocation + '/accounts/password_reset.html', // パスワード再設定
  },
  member: {
    mypagetop: ceclocation + '/mypage/mypage_top.html',
    index: ceclocation + '/mypage/', // マイページ
    customer: ceclocation + '/mypage/customer.html', // 会員情報編集
    customerConfirm: ceclocation + '/mypage/customer_confirm.html', // 会員情報編集確認
    passChange: ceclocation + '/mypage/pass_change.html', // パスワード変更
    passChangeComplete: ceclocation + '/mypage/pass_change_complete.html', // パスワード変更完了
    address: ceclocation + '/mypage/address', // アドレス帳一覧
    addressEdit: ceclocation + '/mypage/address-edit.html', // アドレス帳編集、確認
    pointList: ceclocation + '/mypage/point_list.html', // ポイント一覧
    coupon: ceclocation + '/mypage/coupon_list.html', // クーポン一覧
    couponDetail: ceclocation + '/mypage/coupon_detail.html', // クーポン詳細
    history: ceclocation + '/mypage/history.html', // 注文履歴
    historyDetail: ceclocation + '/mypage/history_detail.html', // 注文履歴詳細
    favorite: ceclocation + '/mypage/favorite.html', // お気に入り
    reviewList: ceclocation + '/mypage/review_list.html', // 商品レビュー一覧
    reviewCustomer: ceclocation + '/mypage/review_customer.html', // 商品レビュー編集
    reviewComfirm: ceclocation + '/mypage/review_comfirm.html', // 商品レビュー確認
    reviewInput: ceclocation + '/mypage/review_input.html', // 商品レビュー登録
    regularHistory: ceclocation + '/mypage/regular',
    regularEdit: ceclocation + '/mypage/regular-edit',

    userCardList: ceclocation + '/mypage/user_card_list.html', // お支払いカード一覧
    arrivalInfo: ceclocation + '/mypage/arrival_infomation.html', // 入荷お知らせ一覧
    userCampaignEvent: ceclocation + '/mypage/user_campaign.html', // キャンペーン・イベント
    userLeave: ceclocation + '/mypage/user_leave.html', // 退会
  },
  others: {
    information: ceclocation + '/information/', // お知らせ
    company: ceclocation + '/company/', // 会社概要
    guide: ceclocation + '/guide/', // ご利用ガイド
    contact: ceclocation + '/contact/', // お問い合わせ
    law: ceclocation + '/law/', // 特定商取引法に基づく表示
    privacypolicy: ceclocation + '/privacypolicy/', // プライバシーポリシー
    snspolicy: ceclocation + '/snspolicy/', // SNSポリシー
    about: ceclocation + '/about/', // サイトについて
    help: ceclocation + '/help/', // ヘルプ
  },
}
